var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.555,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.719 20.553l4.859 5.34a16.249 16.249 0 0122.953 1.084l5.341-4.86a23.468 23.468 0 00-33.153-1.564zM0 9.87l4.86 5.342a30.69 30.69 0 0143.354 2.044l5.34-4.858A37.911 37.911 0 000 9.87zm22.705 18.067a4.634 4.634 0 106.544.31 4.634 4.634 0 00-6.544-.309z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.4025a1be34e0be7ec159d8ef8a173a38.svg";
export { ForwardRef as ReactComponent };